export default __webpack_public_path__ + "57e21204472fa3be51e2e4089829a784.svg";